// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_C3lga","after-pay-info":"after-pay-info_ymyBj","msg":"msg_MhobJ","title-img":"title-img_X5JdE","sub-title":"sub-title_P4nRf"};